<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true" label-width="80px" :rules="rules">
					<el-row>
						<el-col :span="24">
							<el-form-item label="附件类型" prop="type"><select-option-dictionary v-model="formParameter.type" dkey="attach-type"></select-option-dictionary></el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="上传附件" prop="path">
								
								<el-upload
									ref="attachUpload" :auto-upload="false" :limit="2"  class="upload-demo" drag action="#"  accept=".pdf" :on-change = "uploadChange">
									<i class="el-icon-upload"></i>
									<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
									<div class="el-upload__tip" slot="tip">只能上传pdf文件,且不超过{{upload.fileSize}}kb</div>
								</el-upload>

							</el-form-item>
						</el-col>
					</el-row>
			</el-form>
		</div>
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/attachment/attachment/attachment.js';
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue';
import { log } from 'console';
import path from 'path';
export default {
	name: 'edit',
	components: {
			popup,
			selectOptionDictionary,
		},
	data() {
		return {
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			parameter: {},
			formParameter: {},
			upload:{ //上传的信息
				fileSize:10240, //限制文件大小
				myFileList:[], //上传的文件
			},
			productId: '',
			path: '/statics/attachment',
			rules:{},
		};
	},
	methods: {
			//打开弹框
			open(parameter, title, disabled, productId, size) {
				this.parameter = parameter;
				this.disabled = disabled;
				this.productId = productId;
				this.$refs.popup.open(title, size);
				this.$nextTick(() => {
					this.init();
				})
			},
			//关闭弹框
			close() {
				this.disabled = false;
				this.$refs.popup.close();
				this.$refs.attachUpload.clearFiles();
			},
			//当更改文件时触发的方法，注意limit要开启大于1
			uploadChange(file, fileList){
				this.upload.myFileList.splice(0, this.upload.myFileList.length);
				this.upload.myFileList.push(file);
				//将附件名称直接放入
				this.formParameter.name = file.name.substring(0, file.name.lastIndexOf('.'));
				this.$forceUpdate(); //刷新之后才会出现
				if(fileList.length > 1){
					this.$refs.attachUpload.uploadFiles.splice(0,1);
				}
			},
			//提交表单
			confirm() {
				//判断一下文件是否大于0，否则不提交
				if(this.upload.myFileList.length <= 0){
					this.$message.error('必须上传附件哦！');
					return;
				}
				let params = new FormData();
				//添加, 将文件也进行手动提交
				params.append('file', this.upload.myFileList[0].raw);
				params.append('name', this.formParameter.name);
				params.append('type', this.formParameter.type);
				params.append('path', this.path);
				console.log(this.productId);
				if(this.productId != '' && this.productId != undefined){
					params.append('productId', this.productId);
				};
				console.log("params", params);
				
				this.$utils.checkForm(this.$refs.form, () => {
					this.confirmLoading = true;
					if (!this.parameter.id) {
						api.saveUpload(params,
							response => {
								this.$utils.msg.success(response.msg);
								this.confirmLoading = false;
								this.close();
								this.$parent.list();
								this.$refs.attachUpload.clearFiles();
							},
							response => {
								this.$utils.msg.warning(response.msg);
								this.confirmLoading = false;
							}
						);
					} else {
						api.update(params,
							response => {
								this.$utils.msg.success(response.msg);
								this.confirmLoading = false;
								this.close();
								this.$parent.list();
								this.$refs.attachUpload.clearFiles();
							},
							response => {
								this.$utils.msg.warning(response.msg);
								this.confirmLoading = false;
							}
						);
					}
				});
			},
			init() {
				this.popupLoading = true;
				//清除等待
				this.confirmLoading = false;
				//清空内容
				this.formParameter = {};
				//清楚校验
				this.$refs.form.clearValidate();
				
				if (this.parameter.id) {
					//编辑查询数据
					let parameter = {
						id: this.parameter.id
					};
					api.toUpdate(parameter, response => {
						this.formParameter = response.data;
						this.popupLoading = false;
					});
				} else {
					//添加
					this.popupLoading = false;
				}
			}
		}
	};
</script>

<style lang="scss" scoped="scoped">
	@import '~common/custom/css/common.scss';
	@import '~common/custom/css/popup/popup.scss';
</style>
